var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1997 25.6076C51.9897 25.9318 50.7377 25.1854 50.4043 23.9412C48.7103 17.6192 44.7251 12.3194 39.1807 9.01208C38.0879 8.36057 37.7063 6.93638 38.3268 5.82531C38.9475 4.71465 40.3328 4.34346 41.4257 4.99497C48.0263 8.9296 52.7709 15.2414 54.7873 22.7667C55.1207 24.011 54.4096 25.2835 53.1997 25.6076Z",
    fill: "#5495C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36678 37.3526C8.15726 37.6767 6.9048 36.9304 6.5714 35.6861C4.55499 28.1608 5.50845 20.3222 9.257 13.6145C9.87769 12.5039 11.263 12.1327 12.3558 12.7842C13.4492 13.436 13.8308 14.8602 13.2097 15.971C10.0612 21.6049 9.26084 28.1896 10.9548 34.5116C11.2882 35.7559 10.5767 37.0284 9.36678 37.3526Z",
    fill: "#5495C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.481 39.5654C51.3952 37.5728 48.3669 33.8717 47.1718 29.4114L45.4881 23.1278C43.363 15.1967 35.8748 10.1664 28.1593 11.055L27.507 8.62051C27.173 7.37419 25.9211 6.62994 24.7116 6.95403C23.5017 7.27822 22.7896 8.54872 23.1236 9.79503L23.7759 12.2295C16.6477 15.3182 12.68 23.4182 14.8051 31.3493L16.4888 37.6329C17.6839 42.0932 16.9119 46.8126 14.3553 50.604C13.7037 51.5832 13.5071 52.8049 13.8163 53.9588C14.3992 56.1341 16.5936 57.4423 18.7089 56.8755L54.8709 47.1859C56.9857 46.6192 58.232 44.3891 57.6492 42.2138C57.34 41.0599 56.5589 40.1002 55.481 39.5654Z",
    fill: "#5495C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2055 61.0459C43.1744 59.9824 45.715 56.1829 45.4459 52.1269L29.3417 56.442C31.1362 60.0893 35.2362 62.1094 39.2055 61.0459Z",
    fill: "#5495C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5921e371.svg";
export { ForwardRef as ReactComponent };